"use client";
import { BuilderInputField } from "@/ui/builder/builder-input-field";
import type { YnsComponentForm } from "../types";
import type { BreadcrumbsStoreBuilderConfigFactory } from "./config";
import type { Data } from "./schema";

export const BreadcrumbsForm: YnsComponentForm<typeof BreadcrumbsStoreBuilderConfigFactory> = ({
	data,
}: {
	data: Data;
}) => {
	return (
		<div className="grid gap-4 relative pb-20">
			<BuilderInputField
				fieldPath="title"
				label="First element in breadcrumbs"
				required
				defaultValue={data.title}
			/>
			<BuilderInputField
				fieldPath="pageTitle"
				label="Fallback title for static pages"
				defaultValue={data.pageTitle}
			/>
		</div>
	);
};
